import React from 'react';

/**
 * Shared section shell with app background + centered max-width content.
 */
export default function ChatWorkspaceSectionShell({
  background,
  contentMaxWidth,
  padding,
  children,
  style,
  ...rest
}) {
  return (
    <div style={{ background, ...style }} {...rest}>
      <div style={{ margin: '0 auto', maxWidth: contentMaxWidth, padding, width: '100%' }}>
        {children}
      </div>
    </div>
  );
}
